/*
Copyright (c) 2015-present NAVER Corp.
name: @egjs/vue-flicking
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-flicking/tree/master/packages/vue-flicking
version: 3.7.3
*/
import NativeFlicking, { DEFAULT_OPTIONS, withFlickingMethods } from '@egjs/flicking';
import ChildrenDiffer from '@egjs/vue-children-differ';
import ListDiffer from '@egjs/list-differ';
import { Vue, Prop, Component } from 'vue-property-decorator';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));

  return ar;
}

/**
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */

var Flicking =
/*#__PURE__*/
function (_super) {
  __extends(Flicking, _super);

  function Flicking() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  var __proto = Flicking.prototype;

  __proto.mounted = function () {
    this.$_pluginsDiffer = new ListDiffer();
    this.$_cloneCount = 0;

    var options = __assign(__assign({}, this.options), {
      renderExternal: true
    });

    this.$_nativeFlicking = new NativeFlicking(this.$el, __assign(__assign({}, options), {
      framework: "vue",
      frameworkVersion: Vue.version
    }));
    var slots = this.$_getSlots();
    this.$_slotDiffer = new ListDiffer(slots, function (vnode) {
      return vnode.key;
    });
    this.$_bindEvents();
    this.$_checkUpdate();

    if (this.options.renderOnlyVisible) {
      // Should update once to update visibles
      this.$forceUpdate();
    }
  };

  __proto.beforeMount = function () {
    this.$_fillKeys();
  };

  __proto.beforeUpdate = function () {
    this.$_fillKeys();
  };

  __proto.beforeDestroy = function () {
    this.$_nativeFlicking.destroy({
      preserveUI: true
    });
  };

  __proto.render = function (h) {
    var classPrefix = this.options.classPrefix || DEFAULT_OPTIONS.classPrefix;
    var viewportData = {
      class: {}
    };
    var cameraData = {
      class: {},
      directives: [{
        name: "children-differ",
        value: this.onUpdate.bind(this)
      }]
    };
    viewportData.class[classPrefix + "-viewport"] = true;
    cameraData.class[classPrefix + "-camera"] = true;
    var panels = this.$_getPanels(h);
    return h(this.tag, [h(this.viewportTag, viewportData, [h(this.cameraTag, cameraData, panels)])]);
  };

  __proto.onUpdate = function (diffResult) {
    var _this = this;

    var flicking = this.$_nativeFlicking;
    var newCloneCount = flicking.getCloneCount();
    this.$_nativeFlicking.sync(diffResult);
    this.$_cloneCount = newCloneCount;
    this.$nextTick(function () {
      _this.$_checkUpdate();
    });
  }; // overrides


  __proto.destroy = function (option) {
    if (option === void 0) {
      option = {};
    }

    this.$_nativeFlicking.destroy(option);
  };

  __proto.$_checkUpdate = function () {
    this.$_checkPlugins();
    this.$_checkCloneCount();
  };

  __proto.$_bindEvents = function () {
    var _this = this;

    var events = Object.keys(NativeFlicking.EVENTS).map(function (key) {
      return NativeFlicking.EVENTS[key];
    });
    events.forEach(function (eventName) {
      _this.$_nativeFlicking.on(eventName, function (e) {
        e.currentTarget = _this; // Make events from camelCase to kebab-case

        _this.$emit(eventName.replace(/([A-Z])/g, "-$1").toLowerCase(), e);
      });
    });

    if (this.options.renderOnlyVisible) {
      this.$_nativeFlicking.on(NativeFlicking.EVENTS.VISIBLE_CHANGE, function (e) {
        _this.$forceUpdate();
      });
    }
  };

  __proto.$_checkPlugins = function () {
    var _a = this.$_pluginsDiffer.update(this.plugins),
        list = _a.list,
        added = _a.added,
        removed = _a.removed,
        prevList = _a.prevList;

    this.$_nativeFlicking.addPlugins(added.map(function (index) {
      return list[index];
    }));
    this.$_nativeFlicking.removePlugins(removed.map(function (index) {
      return prevList[index];
    }));
  };

  __proto.$_checkCloneCount = function () {
    var prevCloneCount = this.$_cloneCount;
    var newCloneCount = this.$_nativeFlicking.getCloneCount();

    if (prevCloneCount !== newCloneCount) {
      this.$forceUpdate();
    }
  };

  __proto.$_getPanels = function (h) {
    var _this = this;

    var flicking = this.$_nativeFlicking;
    var wholeSlots = this.$_getSlots();

    if (wholeSlots.length === 0) {
      return [];
    }

    var lastIndex = flicking ? flicking.getLastIndex() : this.options.lastIndex || DEFAULT_OPTIONS.lastIndex;
    var slots = wholeSlots.slice(0, lastIndex + 1);
    var panels;

    if (this.options.renderOnlyVisible && this.$_slotDiffer) {
      var slotsDiff = this.$_slotDiffer.update(slots);
      var panelCnt_1 = slots.length;
      flicking.beforeSync(slotsDiff);
      var indexesToRender = flicking.getRenderingIndexes(slotsDiff);
      panels = indexesToRender.map(function (index) {
        if (index >= panelCnt_1) {
          var relativeIndex = index % panelCnt_1;
          var origSlot = slots[relativeIndex];
          return _this.$_cloneVNode(origSlot, h, Math.floor(index / panelCnt_1) - 1, relativeIndex);
        } else {
          return slots[index];
        }
      });
    } else {
      panels = __spread(slots, this.$_getClonedVNodes());
    }

    return panels;
  };

  __proto.$_getSlots = function () {
    // Only elements are allowed as panel
    return this.$slots.default ? this.$slots.default.filter(function (slot) {
      return slot.tag;
    }) : [];
  };

  __proto.$_getClonedVNodes = function () {
    var _this = this;

    var h = this.$createElement;
    var cloneCount = this.$_nativeFlicking ? this.$_nativeFlicking.getCloneCount() : 0;
    var lastIndex = this.$_nativeFlicking ? this.$_nativeFlicking.getLastIndex() : this.options.lastIndex || DEFAULT_OPTIONS.lastIndex;
    var slots = this.$_getSlots();
    var children = slots.slice(0, lastIndex + 1);
    var clones = [];

    var _loop_1 = function (cloneIndex) {
      clones.push.apply(clones, __spread(children.map(function (child, childIdx) {
        return _this.$_cloneVNode(child, h, cloneIndex, childIdx);
      })));
    };

    for (var cloneIndex = 0; cloneIndex < cloneCount; cloneIndex++) {
      _loop_1(cloneIndex);
    }

    return clones;
  };

  __proto.$_cloneVNode = function (vnode, h, cloneIndex, childIndex) {
    var _this = this;

    var key = cloneIndex != null ? "clone" + cloneIndex + "-" + (vnode.key != null ? vnode.key : childIndex) : undefined;
    var clonedChilds = vnode.children ? vnode.children.map(function (child) {
      return _this.$_cloneVNode(child, h);
    }) : undefined;
    var clone = h(vnode.tag, vnode.data, clonedChilds);
    clone.text = vnode.text;
    clone.isComment = vnode.isComment;
    clone.componentOptions = vnode.componentOptions;
    clone.context = vnode.context;
    clone.ns = vnode.ns;
    clone.isStatic = vnode.isStatic;
    clone.key = key;
    return clone;
  };

  __proto.$_fillKeys = function () {
    this.$_getSlots().forEach(function (node, index) {
      if (node.key == null) {
        node.key = node.tag + "-" + index;
      }
    });
  };

  __decorate([Prop({
    type: String,
    default: "div",
    required: false
  })], Flicking.prototype, "tag", void 0);

  __decorate([Prop({
    type: String,
    default: "div",
    required: false
  })], Flicking.prototype, "viewportTag", void 0);

  __decorate([Prop({
    type: String,
    default: "div",
    required: false
  })], Flicking.prototype, "cameraTag", void 0);

  __decorate([Prop({
    type: Object,
    default: function () {
      return {};
    },
    required: false
  })], Flicking.prototype, "options", void 0);

  __decorate([Prop({
    type: Array,
    default: function () {
      return [];
    },
    required: false
  })], Flicking.prototype, "plugins", void 0);

  __decorate([withFlickingMethods], Flicking.prototype, "$_nativeFlicking", void 0);

  Flicking = __decorate([Component({
    directives: {
      "children-differ": ChildrenDiffer
    }
  })], Flicking);
  return Flicking;
}(Vue);

var version = "3.7.3";

var install = function (Vue) {
  Vue.component("Flicking", Flicking);
};

var plugin = {
  Flicking: Flicking,
  install: install,
  version: version
};

export default plugin;
export { Flicking, install, version };
//# sourceMappingURL=flicking.esm.js.map
